import React from 'react';
import './App.scss';
import MainRouter from './router/MainRouter/MainRoutes';

const App: React.FC<{}> = () => {
    return (
            <MainRouter />
    )
}

export default App;